import {FormProvider, useForm} from 'react-hook-form';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {StatusSelectInput} from './status-select-input';
import {Button} from '@/shadcn_components/ui/button';
import axios from 'axios';
import {apiService} from '@/lib/ApiService';
import {SelectInputProps} from '@/components/refinedev/SelectInput';
import Spinner from '@/components/basic/Spinner';
import {SaveIcon} from 'lucide-react';
import {defaultMutationOptions} from '@/pages/_utils';
import {useCan} from '@refinedev/core';
import {TaskStatuses} from '../types';

type StatusSelectFormProps = {
  resource: string;
  id: string;
  initialStatus: string;
} & Partial<SelectInputProps>;

export const StatusSelectForm = ({
  resource,
  id,
  initialStatus,
  ...props
}: StatusSelectFormProps) => {
  //   const queryClient = useQueryClient();
  const methods = useForm({
    defaultValues: {
      status: initialStatus,
    },
  });

  const {mutate, isLoading} = useMutation({
    mutationFn: async (data: {status: string}) => {
      //   console.log('data', data);
      return apiService[resource].updateStatus(id, data.status);
    },
    onError: defaultMutationOptions.onError,
    onSuccess: async (data, vars, ctx) => {
      methods.reset(vars);
      await defaultMutationOptions.onSuccess?.(data, vars, ctx);
      //   queryClient.invalidateQueries({queryKey: ['tasks']});
    },
  });

  const onSubmit = (data: {status: string}) => {
    mutate(data);
  };

  const {data: canAccess} = useCan({
    resource: resource,
    action: 'updateStatus',
    params: {id},
  });

  // if (canAccess?.can === false)
  //   return TaskStatuses.find(s => s.id === initialStatus)?.label || initialStatus;

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} className="flex flex-row gap-2 items-center">
        <StatusSelectInput source="status" {...props} />
        {methods.formState.isDirty &&(
          <Button
            variant="outline"
            size="sm"
            type="submit"
            disabled={isLoading}
            title="Lưu trạng thái">
            {isLoading ? <Spinner /> : <SaveIcon />}
          </Button>
        )}
      </form>
    </FormProvider>
  );
};
